import axios from "../../config/axiosConfig";
import {
  CREATE_WORKER_ATTENDANCE_MONTHLY, DELETE_WORKER_ATTENDANCE_MONTHLY,
  GET_WORKER_ATTENDANCE_MONTHLY,
  WORKER_ATTENDANCE_MONTHLY_REQUEST,
  WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE,
  UPDATE_WORKER_ATTENDANCE_MONTHLY
} from "../types/worker-attendance-monthly-types";

export const getWorkerAttendanceMonthly = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/worker-attendance-monthly/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WORKER_ATTENDANCE_MONTHLY, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createWorkerAttendanceMonthly = (workerAttendanceMonthly) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST });
      const newWorkerAttendanceMonthly = {
        ...workerAttendanceMonthly
      };
      return axios.post("/worker-attendance-monthly/add", newWorkerAttendanceMonthly,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_WORKER_ATTENDANCE_MONTHLY, payload: response.data });
        } else {
          dispatch({
            type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE,
            error: "Worker Attendance Monthly create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateWorkerAttendanceMonthly = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST });
      const { auth } = getState();
      return axios.put("/worker-attendance-monthly/update", { id, data },
        { params: {
          userId: auth.user?.id,
          companyId: data.Company_Id || auth.company?.id,
          finyearId: data.Finyear_Id || auth.finyear?.id,
          customerId: data.Customer_Id || auth?.user?.Customer_Id,
        }}
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_WORKER_ATTENDANCE_MONTHLY,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE,
            error: "Worker Attendance Monthly update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteWorkerAttendanceMonthly = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST });
      return axios.delete(`/worker-attendance-monthly/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_WORKER_ATTENDANCE_MONTHLY, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WORKER_ATTENDANCE_MONTHLY_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};